import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { adminPaymentReportWeekly } from "../../api";
import ReportTablePage from "../../components/admin/ReportTablePage";

function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

export default function PaymentReportByWeek() {
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState("perumahan");
  const [dateValue, setDateValue] = useState(todayStr());
  const [search, setSearch] = useState("");
  const [summary, setSummary] = useState({});
  const [kawasanSummary, setKawasanSummary] = useState([]);
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      const res = await adminPaymentReportWeekly({ template, date: dateValue });
      setSummary(res.summary || {});
      setKawasanSummary(res.kawasan_summary || []);
      setItems(res.items || []);
    } catch (e) {
      await Swal.fire({ icon: "error", title: "Gagal", text: e?.response?.data?.error || "Gagal load laporan bayaran mingguan." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [template, dateValue]);

  return (
    <ReportTablePage
      title="Laporan Bayaran Mingguan"
      subtitle="Rekod bayaran ikut minggu."
      loading={loading}
      template={template}
      setTemplate={setTemplate}
      dateMode="date"
      dateValue={dateValue}
      setDateValue={setDateValue}
      search={search}
      setSearch={setSearch}
      summary={summary}
      kawasanSummary={kawasanSummary}
      items={items}
      onRefresh={load}
      itemColumns={[
        { key: "no_akaun", label: "No Akaun" },
        { key: "nombor_unit", label: "Unit" },
        { key: "kawasan", label: "Kawasan" },
        { key: "paid_at", label: "Tarikh Bayar", render: (v) => (v ? new Date(v).toLocaleString() : "-") },
        { key: "amount", label: "Jumlah (RM)" },
        { key: "receipt_no", label: "Receipt" },
      ]}
    />
  );
}